import { HTMLContent } from './HTMLContent'

export class RichText extends HTMLContent {
  parse() {
    let spans = this.content.spans
    let text = this.content.text.split('')

    this.last = null

    spans.forEach(({ start, end, type, data }, i) => {
      let tag = this.getTags(type, data)
      let offset = this.getOffset(i, start, end)

      if (tag) {
        text.splice(start + offset.open, 0, tag.open)
        text.splice(end + offset.close, 0, tag.close)
      }
    })

    this.content = text.join('')
    return this
  }

  getOffset(index, start, end) {
    let offset = index * 2
    let nested = this.last > start

    this.last = end
    return {
      open: (nested) ? offset - 1 : offset,
      close: (nested) ? offset : ++offset
    }
  }

  getTags(type, data) {
    const T_ = {
      em: () => ({ open: '<em>', close: '</em>' }),
      strong: () => ({ open: '<strong>', close: '</strong>' }),
      hyperlink: ({ value }) => ({ open: `<a href="${value.url}" target="_blank">`, close: '</a>' })
    }

    let tags = (!T_[type]) ? false
      : T_[type](data)

    return tags
  }
}



// WEBPACK FOOTER //
// ./src/api/classes/RichText.js